import React, { FunctionComponent } from 'react';

import Flex from '@components/layout/flex';
import Avatar from '@components/basics/avatar';
import Typography from '@components/basics/typography';
import UnselectedIcon from '@components/basics/icons/unselected';
import CompletedIcon from '@components/basics/icons/achievements-icons/completed';
import styled from 'styled-components';

interface RosterArtistItemProps {
  className?: string;
  avatar?: string;
  name: string;
  selected?: boolean;
  onClick: () => void;
}

const RosterArtistItem: FunctionComponent<RosterArtistItemProps> = ({
  className,
  avatar,
  name,
  selected,
  onClick,
}) => {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      className={className || ''}
    >
      <Flex justifyContent="flex-start" alignItems="center" gap={10}>
        <Avatar src={avatar} className="avatar" />
        <Typography weight="700">{name}</Typography>
      </Flex>
      {selected ? (
        <CompletedIcon className="icon" onClick={onClick} />
      ) : (
        <UnselectedIcon className="icon" onClick={onClick} />
      )}
    </Flex>
  );
};

export default styled(RosterArtistItem)`
  .avatar {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon {
    cursor: pointer;
    width: 32px;
    height: 32px;
  }
`;
